/* global Provider */
import React, { Component } from 'react';
import HelpContent from './HelpContent';
import Step from './Step';

export default class BeginStep extends Component {
    render() {
        let helpContent = <HelpContent />;
        return (
            <Step className={this.props.className}>
                <h1 className="clearfix">    
                    A Framework for Aligning TDF Selection with the DOL Tips                           
                    <i className="fas fa-question-circle" onClick={() => {
                        Provider.showModal('Additional Support', helpContent, '');
                    }}></i>
                </h1>
                <div className="img img-overlay"></div>
                <p>
                    Target-Date Blueprint is designed to provide a prudent process that advisors can follow in order to maintain the Safe Harbor status of the TDFs that are recommended to plan sponsors.
                </p>
                <ul>
                    <li>It starts with a comprehensive profiling questionnaire that documents the characteristics of the plan's participants.</li>
                    <li>Forward-looking analysis across the full glide path determines which TDFs most closely align with the profile of the plan and its participants.</li>
                    <li>TDFs are ranked by quartile, from most to least suitable.</li>
                </ul>
                <div className="mt-4 mb-4 row justify-content-center d-none">
                    <div className="col-4">
                        <div className="form-group ">
                            <label htmlFor="username">Your Name:</label>
                            <input type="text" className="form-control" id="username" placeholder="Your Name" onChange={(event) => {
                                Provider.setUsername(event.target.value);
                            }}/>
                        </div>                    
                        <div className="form-group">
                            <label htmlFor="email">Email Address:</label>
                            <input type="email" className="form-control" id="email" placeholder="Email Address" onChange={(event) => {
                                Provider.setEmail(event.target.value);
                            }} />
                        </div>
                    </div>
                </div>                
                <div className="mt-4 text-center">
                    <button className="btn btn-lg btn-primary" onClick={(event) => {
                        this.props.onBeginClick();
                        event.target.blur();
                    }}>Begin Evaluation</button>
                </div>
            </Step>
        )
    }
}